import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { ILineBreakBehavior } from "../../../../documaker/domain/format/objects";

export interface ILineBreakBehaviorPropertyEditable {
  lineBreakBehavior(): IPropertyEditable<ILineBreakBehavior>;
}

export function instanceOfILineBreakBehaviorPropertyEditable(instance: any): instance is ILineBreakBehaviorPropertyEditable {
  return instance
      && instance.lineBreakBehavior
      && instanceOfIPropertyEditable<ILineBreakBehavior>(instance.lineBreakBehavior());
}
